module.exports = __webpack_public_path__ + "img/spxc.284fa1c6.png";